/* T FOR ALL — product page: size/length "dropdowns" (built on Dawn's variant radios).
   - closes an open list when clicking outside or after picking a value
   - every option shows "Select <option>" until the customer picked it herself
     (Dawn pre-selects a variant and re-renders the picker after each change)
   - "Add to cart" opens the first option that hasn't been chosen yet
   - the perfect size from the quiz (localStorage tfa-perfect-size: size + inseam) is picked
     on arrival, as if the customer chose it */
(function () {
  // Opened with ?variant=... (shared link, back from cart): treat everything as chosen.
  var startedUnselected = !/[?&]variant=/.test(location.search);
  var chosen = new Set();

  function applyPlaceholders() {
    if (!startedUnselected) return;
    document.querySelectorAll('.tfa-select__details[data-option]').forEach(function (details) {
      var value = details.querySelector('.tfa-select__value');
      if (chosen.has(details.dataset.option)) {
        if (details.hasAttribute('data-unselected')) details.removeAttribute('data-unselected');
        var checked = details.querySelector('input[type="radio"]:checked');
        if (value && checked && value.textContent !== checked.value) value.textContent = checked.value;
      } else {
        if (!details.hasAttribute('data-unselected')) details.setAttribute('data-unselected', '');
        var placeholder = details.dataset.placeholder;
        if (value && placeholder && value.textContent !== placeholder) value.textContent = placeholder;
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.tfa-select__details input')) return;
    document.querySelectorAll('.tfa-select__details[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  function choose(input) {
    var details = input.closest && input.closest('.tfa-select__details');
    if (!details) return;
    chosen.add(details.dataset.option);
    details.removeAttribute('open');
    details.removeAttribute('data-unselected');
    details.removeAttribute('data-attention');
    var value = details.querySelector('.tfa-select__value');
    if (value) value.textContent = input.value;
  }

  document.addEventListener('change', function (event) {
    choose(event.target);
  });

  // Dawn pre-selects a variant: picking that (already checked) value fires no
  // 'change', so handle the click too, or the first size can never be chosen.
  document.addEventListener('click', function (event) {
    var input = event.target;
    if (input.type === 'radio' && input.checked) choose(input);
  });

  document.addEventListener(
    'click',
    function (event) {
      var submit = event.target.closest && event.target.closest('.product-form__submit');
      if (!submit) return;
      var scope = submit.closest('.shopify-section') || document;
      var pending = scope.querySelector('.tfa-select__details[data-unselected]');
      if (!pending) return;
      event.preventDefault();
      event.stopPropagation();
      pending.setAttribute('open', '');
      pending.setAttribute('data-attention', '');
      pending.querySelector('summary').focus();
    },
    true
  );

  // "M (EU38)", "XXL (W44-L36)" -> "M", "2XL" (same as assets/tfa-quiz.js)
  function sizeKey(value) {
    var key = String(value).trim().split(/[\s(]/)[0].toUpperCase();
    return key.replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL');
  }

  // 36" -> 36; torso lengths like "Tall" have no inseam
  function inseamOf(value) {
    var match = String(value).match(/^(\d{2})\s*("|″|''|inch)?$/i);
    return match ? match[1] : '';
  }

  // The quiz result: check the size (and inseam) radios, then let Dawn load that variant.
  function applyQuizSize() {
    if (!startedUnselected) return;
    var perfect;
    try {
      perfect = JSON.parse(localStorage.getItem('tfa-perfect-size') || 'null');
    } catch (e) {
      return;
    }
    if (!perfect || !perfect.size) return;
    var picker = document.querySelector('.product variant-selects, variant-selects');
    if (!picker) return;
    var picked = [];
    picker.querySelectorAll('.tfa-select__details[data-option]').forEach(function (details) {
      var radios = Array.from(details.querySelectorAll('input[type="radio"]'));
      var match =
        radios.find(function (r) { return sizeKey(r.value) === perfect.size && !inseamOf(r.value); }) ||
        (perfect.length && radios.find(function (r) { return inseamOf(r.value) === perfect.length; }));
      if (match) picked.push(match);
    });
    if (!picked.length) return;
    picked.forEach(function (input) {
      input.checked = true;
      choose(input);
    });
    picked[picked.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
  }

  // After every deferred script ran, so Dawn's product-info is listening for the change.
  if (document.readyState === 'complete') {
    applyQuizSize();
  } else {
    window.addEventListener('load', applyQuizSize, { once: true });
  }

  // Re-apply after Dawn swaps the variant picker HTML.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      applyPlaceholders();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
